import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import oznamenie from "./assets/invitation.png";
import { Typography } from "@mui/material";
import { useT } from "talkr";

export default function WeddingBefore6pmDialog() {
  const [open, setOpen] = React.useState(true);
  const [_, setIsConfirmed] = React.useState(false);
  const { T } = useT();
  

  const handleConfirmation = () => {
    setIsConfirmed(true);
    window.open(T("wedding_before6pm_dialog.url"), "_blank");
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogContent
          style={{
            margin: 0,
            padding: 0,
          }}
        >
          <img
            src={oznamenie}
            alt="oznamenie"
            style={{
              width: "100%",
              margin: 0,
              display: "block",
            }}
          />
        </DialogContent>
        <DialogActions
          sx={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "background.default",
          }}
        >
          <Typography
            variant={window.innerWidth < 768 ? "h6" : "h4"}
            component="div"
            style={{
              padding: "10px",
              textAlign: "center",
              fontFamily: "FUTURAM",
              fontSize: window.innerWidth < 768 ? "1rem" : "1.1rem",
            }}
          >
            {T("wedding_before6pm_dialog.title")}
          </Typography>
          <Button
            onClick={handleConfirmation}
            autoFocus
            variant="text"
            color="primary"
            sx={{
              fontSize: "0.85rem",
              padding: "4px 10px",
              minWidth: "unset",
              color: "red",
              whiteSpace: "pre-line",
              textAlign: "center",
            }}
          >
            {T("wedding_before6pm_dialog.confirm_button")}
          </Button>
          <Button
            onClick={handleClose}
            variant="text"
            color="primary"
            sx={{
              fontSize: "0.85rem",
              padding: "4px 10px",
              minWidth: "unset",
            }}
          >
            {T("wedding_before6pm_dialog.close_button")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
